import React, { useEffect, useState } from "react";

import { useParams } from "react-router";

import { methods } from "api/methods";
import { Nutrient } from "api/models";
import { resources } from "api/resources";
import { useApi } from "api/useApi";
import { PageLoadStateProvider } from "components/common";
import { TranslationProvider } from "components/useTranslations";

import NutrientsDetailsForm from "./NutrientsDetailsForm";
import NutrientsDetailsHeader from "./NutrientsDetailsHeader";

const NutrientsDetailsPage: React.FC = () => {
  const execute = useApi();

  const params = useParams();

  const [nutrientData, setNutrientData] = useState<Nutrient>();
  const [breadcrumbName, setBreadcrumbName] = useState<string>();

  useEffect(() => {
    if (params.nutrientKey) {
      execute(resources.nutrient(params.nutrientKey), methods.GET)
        .then((response: Nutrient) => {
          setNutrientData(response);
          setBreadcrumbName(response.name);
        })
        .catch(() => {});
    } else {
      execute(resources.newNutrient, methods.GET)
        .then((response: Nutrient) => {
          if (!response.isInvalid) {
            setNutrientData(response);
            setBreadcrumbName(response.name);
          }
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.nutrientKey]);
  return (
    <PageLoadStateProvider isLoaded={!!nutrientData?.translations}>
      <TranslationProvider translations={nutrientData?.translations}>
        {() => (
          <>
            <NutrientsDetailsHeader
              nutrient={nutrientData}
              displayName={breadcrumbName}
            />
            <NutrientsDetailsForm
              nutrient={nutrientData}
              onNameSaved={setBreadcrumbName}
            />
          </>
        )}
      </TranslationProvider>
    </PageLoadStateProvider>
  );
};

export default NutrientsDetailsPage;
